import { createAction } from 'redux-actions';

export const getRules = createAction('GET_RULES');
export const getRulesSuccess = createAction('GET_RULES_SUCCESS');
export const getRulesFailure = createAction('GET_RULES_FAILURE');

export const createRule = createAction('CREATE_RULE');
export const createRuleSuccess = createAction('CREATE_RULE_SUCCESS');
export const createRuleFailure = createAction('CREATE_RULE_FAILURE');

export const updateRule = createAction('UPDATE_RULE');
export const updateRuleSuccess = createAction('UPDATE_RULE_SUCCESS');
export const updateRuleFailure = createAction('UPDATE_RULE_FAILURE');

export const deleteRule = createAction('DELETE_RULE');
export const deleteRuleSuccess = createAction('DELETE_RULE_SUCCESS');
export const deleteRuleFailure = createAction('DELETE_RULE_FAILURE');
